const BUSINESS_TYPES = [
  {
    label: "농업 판매점 / 농장 상점",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "동물 보호소 / 자선 단체",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "비육 송아지 사육장",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "소고기 생산자",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "육계", value: "Broilers", id: "broilers" },
  {
    label: "구매 그룹",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "송아지 생산",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "송아지 목장 / 육성업체",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "가축 구매자", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "계약 사육업체",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "협동조합", value: "Cooperative", id: "cooperative" },
  {
    label: "법인 사무실",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "번식우 / 송아지 운영",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "낙농 생산",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "유통업체 / 대리점",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "사료 공장", value: "Feed Mill", id: "feed_mill" },
  { label: "사육장", value: "Feedyard", id: "feedyard" },
  {
    label: "재배자/재배장",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "부화장", value: "Hatchery", id: "hatchery" },
  {
    label: "암소 생산",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "산란계 통합업체",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "산란계", value: "Layers", id: "layers" },
  { label: "미디어", value: "Media", id: "media" },
  {
    label: "우유 협동조합/구매자",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "혼합/기타 생산자",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "영양소 공급업체",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "포장/가공업체",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "반려동물 소매점",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "약국", value: "Pharmacy", id: "pharmacy" },
  {
    label: "가금류 사육업체",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "가금류 통합업체",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "양 생산자", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "비육우 운영",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "가축 시장/경매장",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "돼지 생산자", value: "Swine Producer", id: "swine_producer" },
  { label: "칠면조", value: "Turkeys", id: "turkeys" },
  {
    label: "대학 / 교육기관",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "동물병원",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "도매업체 / 소매업체",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "양모 구매자", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "필수",
    },
  },
  salutation: {
    label: "호칭",
    placeholder: "호칭 선택",
    errors: {
      required: "호칭은 필수입니다",
      invalid: "유효한 호칭을 선택하세요",
    },
  },
  firstName: {
    label: "이름",
    placeholder: "홍길동",
    errors: {
      authenticatedNameUpdateTrial:
        "로그인되어 있어 이름을 변경할 수 없습니다.",
      required: "이름은 필수입니다",
      minLength: "이름은 최소 2자 이상이어야 합니다",
      maxLength: "이름은 최대 50자 이내여야 합니다",
    },
  },
  lastName: {
    label: "성",
    placeholder: "김",
    errors: {
      authenticatedNameUpdateTrial:
        "로그인되어 있어 이름을 변경할 수 없습니다.",
      required: "성은 필수입니다",
      minLength: "성은 최소 2자 이상이어야 합니다",
      maxLength: "성은 최대 50자 이내여야 합니다",
    },
  },
  email: {
    label: "이메일",
    placeholder: "hong.gildong@example.com",
    description: "공유 이메일이 아닌 개인 이메일 주소를 입력하세요.",
    prefixWarningTitle: "공유 메일함 감지됨",
    prefixWarningDescription:
      "더 나은 개인화된 경험을 위해 개인 이메일 주소 사용을 권장합니다",
    errors: {
      authenticatedEmailUpdateTrial:
        "로그인되어 있어 이메일 주소를 변경할 수 없습니다.",
      required: "이메일은 필수입니다",
      invalidEmail: "유효한 이메일 주소를 입력하세요",
      emailAssociatedWithYourAccount:
        "이메일 주소가 계정과 연결되어 있어 변경할 수 없습니다.",
    },
  },
  confirmEmail: {
    label: "이메일 확인",
    placeholder: "hong.gildong@example.com",
    errors: {
      authenticatedEmailUpdateTrial:
        "로그인되어 있어 이메일 주소를 변경할 수 없습니다.",
      required: "이메일 확인은 필수입니다",
      invalidEmail: "유효한 이메일 주소를 입력하세요",
      emailMatchError: "이메일 주소가 일치하지 않습니다",
    },
  },
  password: {
    label: "비밀번호",
    placeholder: "비밀번호를 입력하세요",
    errors: {
      required: "비밀번호는 필수입니다",
    },
  },
  confirmPassword: {
    label: "비밀번호 확인",
    placeholder: "비밀번호를 다시 입력하세요",
    errors: {
      required: "비밀번호 확인은 필수입니다",
      passwordMatchError: "비밀번호가 일치하지 않습니다",
    },
  },
  addressLine1: {
    label: "주소 1",
    placeholder: "서울시 강남구 테헤란로 123",
    errors: {
      required: "주소 1은 필수입니다",
      minLength: "주소 1은 최소 5자 이상이어야 합니다",
      maxLength: "주소 1은 최대 100자 이내여야 합니다",
    },
  },
  addressLine2: {
    label: "주소 2",
    placeholder: "101동 1001호",
    errors: {
      required: "주소 2는 필수입니다",
      maxLength: "주소 2는 최대 100자 이내여야 합니다",
    },
  },
  city: {
    label: "도시",
    placeholder: "서울",
    errors: {
      required: "도시는 필수입니다",
      minLength: "도시는 최소 2자 이상이어야 합니다",
      maxLength: "도시는 최대 50자 이내여야 합니다",
    },
  },
  country: {
    label: "국가",
    placeholder: "국가 선택",
    errors: {
      required: "국가는 필수입니다",
      invalid: "유효한 국가를 선택해주세요",
    },
  },
  state: {
    label: "주",
    placeholder: "주를 선택하세요",
    errors: {
      required: "주는 필수입니다",
      invalid: "유효한 주를 선택하세요",
    },
  },
  jurisdiction: {
    label: "관할 지역",
    placeholder: "관할 지역을 선택하세요",
    errors: {
      required: "관할 지역은 필수입니다",
      invalid: "유효한 관할 지역을 선택하세요",
    },
  },
  zipCode: {
    label: "우편번호",
    placeholder: "06234",
    errors: {
      required: "우편번호는 필수입니다",
      invalid: "유효한 우편번호를 입력하세요",
    },
  },
  role: {
    label: "역할",
    placeholder: "역할을 선택하세요",
    errors: {
      required: "역할을 선택하세요",
      invalid: "유효한 역할을 선택하세요",
    },
  },
  businessType: {
    label: "사업 유형",
    placeholder: "사업 유형을 선택하세요",
    errors: {
      required: "사업 유형은 필수입니다",
      invalid: "유효한 사업 유형을 선택하세요",
    },
  },
  businessName: {
    label: "사업체 이름",
    placeholder: "사업체 이름을 입력하세요",
    errors: {
      required: "사업체 이름은 필수입니다",
      minLength: "사업체 이름은 최소 2자 이상이어야 합니다",
      maxLength: "사업체 이름은 최대 100자 이내여야 합니다",
    },
  },
  businessSearch: {
    label: "사업체 검색:",
    addNewAccount: "새 사업체 계정 추가",
    canNotFindBusiness: "사업체를 찾을 수 없나요?",
    guideline: "우편번호를 입력한 다음 아래 목록에서 선택하세요.",
    guidelineForNameSearch:
      "사업체의 전체 이름을 입력한 다음 목록에서 선택하세요.",
    placeholder: "어디서 일하시나요?",
    noResults: "결과를 찾을 수 없습니다",
    searching: "검색 중...",
    selectedBusinessHeading: "선택된 사업체:",
    selectedBusinessNotCorrect: "올바르지 않나요?",
    selectedBusinessTryAgain: "다시 시도",
    selectedBusinessDismiss: "사업체 해제",
    resultsFound: {
      singular: "1개의 사업체를 찾았습니다",
      plural: "여러 사업체를 찾았습니다",
    },
    errors: {
      network:
        "사업체 검색 서비스 연결에 문제가 있습니다. 나중에 다시 시도하세요.",
    },
  },
  explicitConsent: {
    label:
      "이 상자를 선택함으로써 Elanco 이용약관에 동의하며, Elanco가 개인정보처리방침에 따라 개인정보를 수집 및 처리하는 것을 확인합니다",
    errors: {
      required: "명시적 동의가 필요합니다",
    },
  },
  explicitSmsConsent: {
    label:
      "이 상자를 선택하면 Elanco로부터 SMS/문자 메시지를 통해 마케팅 커뮤니케이션을 수신하는 데 동의합니다.",
    errors: {
      required: "SMS 수신 동의가 필요합니다",
    },
  },
  telephone: {
    label: "개인 전화",
    placeholder: "개인 전화번호를 입력하세요",
    dialCodeLabel: "코드",
    dialCodePlaceholder: "국가 검색...",
    errors: {
      invalid: "유효한 전화번호를 입력하세요.",
    },
  },
  businessTelephone: {
    label: "사업체 전화",
    placeholder: "사업체 전화번호를 입력하세요",
    dialCodeLabel: "코드",
    dialCodePlaceholder: "국가 검색...",
    errors: {
      invalid: "유효한 전화번호를 입력하세요.",
    },
  },
  professionalNumber: {
    label: "전문가 번호",
    placeholder: "1234567",
    errors: {
      required: "전문가 번호를 입력하세요",
      maxLength: "입력이 문자 제한을 초과합니다",
    },
  },
  addressSearch: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  businessSearchField: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  checkbox: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  checkboxGroup: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  combobox: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  datePicker: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  dateRange: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  dateTime: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  emailField: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  fileInput: {
    errors: {
      required: "파일을 선택하세요",
    },
  },
  number: {
    errors: {
      required: "숫자를 입력하세요",
      minValue: "최소값보다 큰 값을 입력하세요",
      maxValue: "최대값보다 작은 값을 입력하세요",
    },
  },
  passwordField: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  rangeSlider: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  select: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  telephoneField: {
    errors: {
      required: "숫자만 입력하세요",
      invalidTelephone: "유효한 전화번호를 입력하세요",
      invalidFormat: "잘못된 번호 형식입니다",
    },
  },
  text: {
    errors: {
      required: "문자(A-Z), 숫자(0-9)만 사용하고 기호는 사용하지 마세요",
      maxLength: "입력이 문자 제한을 초과합니다",
      minLength: "입력은 최소 2자 이상이어야 합니다",
    },
  },
  textarea: {
    characters: "문자",
  },
  time: {
    errors: {
      required: "이 필드는 필수입니다",
    },
  },
  form: {
    errors: {
      generic: "양식 제출 중 오류가 발생했습니다. 다시 시도하세요.",
      reportAnIssue: "문제 보고하기.",
      configuration: "구성 오류",
      noFormQuestionsAvailable: "사용 가능한 양식 항목이 없습니다.",
      formComponentLoad:
        "지원되지 않는 필드로 인해 양식 구성 요소를 로드할 수 없습니다.",
      code: "코드",
      type: "유형",
      missingRequiredFields:
        "양식에 필수 필드(이메일 및/또는 동의)가 누락되었습니다. 양식 구성을 수정하려면 관리자에게 문의하세요.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "동물 복지 - 수의사",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "생산자 - 혼합/기타",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "소매업체",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "양 생산자",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "수의사",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "수의사", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "수의사, 병원 소유자",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "수의사 보조원",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "수의사 간호사",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "수의과 - 기타",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "수의과 - 수의사",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "수의과 - 수의사 간호사",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "수의사 전문가",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "수의사",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "박사",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "씨",
    value: "M.",
    id: "m",
  },
  {
    label: "양",
    value: "Miss",
    id: "miss",
  },
  {
    label: "씨",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "여사",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "씨",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "교수",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
